import script from "./ImageBrief.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageBrief.vue?vue&type=script&setup=true&lang=js"

import "./ImageBrief.vue?vue&type=style&index=0&id=43548906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43548906"]])

export default __exports__